import "babel-polyfill";

import ConfigurationForm from './ConfigurationForm/ConfigurationForm';
import Angletool from './Angletool/Angletool';

$(document).ready(function() {

	new ConfigurationForm();

	if(document.getElementById('angletool')) {
		new Angletool();
	}
});
